<span>Версия <span id="version-span-inner">buildTimeReplacedVersion</span></span>

<style>
    #version-span-inner {
        color: rgb(122, 122, 122);
    }
</style>
